import { CLEAR_ALL } from "../actions_all";
import {
    DataActionTypes,
    DataState,
    SET_POPULATION_FEATURE_DISTRIBUTIONS,
    CLEAR_POPULATION_FEATURE_DISTRIBUTIONS,
    SET_POPULATION_DATA,
    CLEAR_POPULATION_DATA,
    ADD_POPULATION_STATS_DATA,
    CLEAR_POPULATION_STATS_DATA
} from "./types";


const initialState: DataState = {
    population_feature_distributions: undefined,
    populations: [],
    population_stats_data: {}
};

export function DataReducer(state=initialState, action: DataActionTypes): DataState {

    let newState = {...state};

    switch (action.type) {

        case SET_POPULATION_FEATURE_DISTRIBUTIONS:
            newState.population_feature_distributions = action.payload;
            break;

        case CLEAR_POPULATION_FEATURE_DISTRIBUTIONS:
            newState.population_feature_distributions = undefined;
            break;
        
        case SET_POPULATION_DATA:
            newState.populations = action.payload;
            break;
        
        case CLEAR_POPULATION_DATA:
            newState.populations = [];
            break;
        
        case ADD_POPULATION_STATS_DATA:
            newState.population_stats_data = {
                ...newState.population_stats_data,
                ...action.payload
            };
            break;

        case CLEAR_POPULATION_STATS_DATA:
            newState.population_stats_data = {};
            break;

        case CLEAR_ALL:
            newState = initialState;
            break;

        default:
            break;
    }

    return newState;
}